import React from "react"
import { ProductCatalog } from "./ProductCatalog"
import { ProductCatalogV2 } from "./ProductCatalogV2"
import { CatalogFetcher } from "../../services/CatalogFetcher"
import { Cart } from "./Cart"
import { PurchaseOrderService } from "../../services/PurchaseOrderService"
import { PurchaseOrderItemService } from "../../services/PurchaseOrderItemService"
import { toast } from "react-toastify"
import { find, findIndex, without } from "lodash-es"

export class OrderCatalog extends React.Component {
  constructor(props) {
    super(props)
    this.createOrUpdateItem = this.createOrUpdateItem.bind(this);
    this.createOrderAndItem = this.createOrderAndItem.bind(this)
    this.updateRequestedOn = this.updateRequestedOn.bind(this)
    this.removeOrderItem = this.removeOrderItem.bind(this)
    this.updateOrderItemQuantity = this.updateOrderItemQuantity.bind(this)
    this.addItem = this.addItem.bind(this)
    this.refetchOrder = this.refetchOrder.bind(this)
    this.state = {
      buyer_order: props.buyer_order || { buyer_order_items: [], requested_on: props.requested_on }
    }
  }

  createOrderAndItem(buyer_order_item_params, product_name, src) {
    const requested_on = this.state.buyer_order.requested_on
    PurchaseOrderService.create(this.props.buyer_id, this.props.seller.id, requested_on).then(
      (buyer_order) => {
        this.setState({ buyer_order: buyer_order })
        this.createOrUpdateItem(buyer_order.id, buyer_order_item_params, product_name, src)
        const newUrl = "/admin/purchase_orders/" + buyer_order.id + "/browse"
        window.history.replaceState({}, "Catalog", newUrl)
      }
    )
  }

  createOrUpdateItem(buyer_order_id, buyer_order_item_params, product_name, src) {
    buyer_order_item_params.buyer_order_id = buyer_order_id
    buyer_order_item_params.src = src
    PurchaseOrderItemService.create(buyer_order_item_params).then(
      (buyer_order_item) => {
        let buyer_order = this.state.buyer_order
        const index = findIndex(buyer_order.buyer_order_items, { id: buyer_order_item.id })
        if ( index === -1 ) {
          buyer_order.buyer_order_items.push(buyer_order_item)
        } else {
          buyer_order.buyer_order_items[index] = buyer_order_item
        }
        this.setState({buyer_order: buyer_order})
        toast('Added to cart: ' + product_name, { className: "bg-success text-white"})
      },
      (error) => { toast(error.message, { className: "bg-danger text-white" }) }
    )
  }

  addItem(buyer_order_item_params, name, src) {
    if (!this.state.buyer_order.id) {
      this.createOrderAndItem(buyer_order_item_params, name, src)
    } else {
      this.createOrUpdateItem(this.state.buyer_order.id, buyer_order_item_params, name, src)
    }
  }

  updateRequestedOn(requested_on) {
    let buyer_order = this.state.buyer_order
    buyer_order.requested_on = requested_on
    if (!this.state.buyer_order.id) {
      this.setState({ buyer_order: buyer_order})
      return
    }
    let payload = { id: this.state.buyer_order.id, requested_on: requested_on }
    PurchaseOrderService.update(payload).then(
      () => { this.setState({ buyer_order: buyer_order}) }
    )
  }

  removeOrderItem(order_item_id) {
    PurchaseOrderItemService.destroy(order_item_id).then(() => {
      this.removeItemFromBuyerOrder(order_item_id)
    })
  }

  removeItemFromBuyerOrder(buyer_order_item_id) {
    let buyer_order = this.state.buyer_order
    let item_to_remove = find(buyer_order.buyer_order_items, { id: buyer_order_item_id })
    const new_buyer_order_items = without(buyer_order.buyer_order_items, item_to_remove)
    buyer_order.buyer_order_items = new_buyer_order_items
    this.setState({ buyer_order: buyer_order })
  }

  updateOrderItemQuantity(buyer_order_item_id, quantity) {
    const buyer_order_item = {
      id: buyer_order_item_id,
      quantity: quantity
    }
    PurchaseOrderItemService.update(buyer_order_item).then(
      (new_purchase_order_item) => {
        toast("Quantity updated", { className: "bg-success text-white" })
        if (new_purchase_order_item.other_items_updated) {
          this.refetchOrder()
          return
        }
        let buyer_order = this.state.buyer_order
        let index = buyer_order.buyer_order_items.findIndex((item) => item.id === buyer_order_item_id)
        buyer_order.buyer_order_items[index] = new_purchase_order_item
        this.setState({ buyer_order: buyer_order })
      },
      (error) => { toast(error.message, { className: "bg-danger text-white" }) }
    )
  }

  // Replaces the whole buyer_order in state instead of splicing one item into it -- used
  // when other_items_updated on a response says some other item changed too, so this one
  // response alone isn't enough to bring the screen back in sync.
  refetchOrder() {
    if (!this.state.buyer_order.id) { return }
    PurchaseOrderService.get(this.state.buyer_order.id).then(
      (buyer_order) => { this.setState({ buyer_order: buyer_order }) }
    )
  }

  renderCart() {
    if (!this.props.seller.accepting_orders || !this.state.buyer_order.id) { return }
    return (
      <Cart buyer_order={this.state.buyer_order}
            removeOrderItem={this.removeOrderItem}
            updateOrderItemQuantity={this.updateOrderItemQuantity}
            seller_browsing={this.props.seller_browsing}
            showProducer={this.props.showProducer} />
    )
  }

  render() {
    const fetcher = (cursor, batch, params) => {
      if ( this.props.private_catalog_id ) {
        return CatalogFetcher.queryCatalog(
          this.props.seller.id,
          this.props.private_catalog_id,
          cursor,
          batch,
          params
        )
      } else {
        return CatalogFetcher.queryAvailable(
          this.props.seller.id,
          cursor,
          batch,
          params
        )
      }
    }

    var VariableCatalog = this.props.anyDateAvailability ? ProductCatalogV2 : ProductCatalog

    return (
      <VariableCatalog
        anyDateAvailability={this.props.anyDateAvailability}
        fetcher={fetcher}
        producers={this.props.producers}
        categories={this.props.categories}
        collections={this.props.collections}
        delivery_dates={this.props.delivery_dates}
        preloaded_products={this.props.preloaded_products}
        preloaded_next_cursor={this.props.preloaded_next_cursor}
        seller={this.props.seller}
        buyer_id={this.props.buyer_id}
        requestedOn={ this.state.buyer_order.requested_on }
        addItem={this.addItem}
        updateRequestedOn={this.updateRequestedOn}
        cartEnabled={this.props.seller.accepting_orders && this.props.buyer_id}
        cart={this.renderCart()}
        showProducer={this.props.showProducer}
        showPricing={this.props.showPricing}
        startTerm={this.props.startTerm}
        selectedProducerId={this.props.selectedProducerId}
        type="buyer"
      />
    )
  }
}
export default OrderCatalog